import { SyncWorkflowSubmitResponse } from '../sync/syncWorkflowResponse';

export const COMPLETE_REQUEST_WORKFLOWS_FAILURE_REASONS = {
  logisticRequestNotFound: 'logisticRequestNotFound',
  alreadyCompleted: 'alreadyCompleted',
  notAllRequestWorkflowsCompleted: 'notAllRequestWorkflowsCompleted',
} as const;

export type CompleteRequestWorkflowsResponseSuccess = {
  isOk: true;
};

export type CompleteRequestWorkflowsResponseLogisticRequestNotFound = {
  isOk: false;
  failureReason: typeof COMPLETE_REQUEST_WORKFLOWS_FAILURE_REASONS.logisticRequestNotFound;
  context: {
    requestNumber: string;
  };
};

export type CompleteRequestWorkflowsResponseAlreadyCompleted = {
  isOk: false;
  failureReason: typeof COMPLETE_REQUEST_WORKFLOWS_FAILURE_REASONS.alreadyCompleted;
};

export type CompleteRequestWorkflowsResponseNotAllRequestWorkflowsCompleted = {
  isOk: false;
  failureReason: typeof COMPLETE_REQUEST_WORKFLOWS_FAILURE_REASONS.notAllRequestWorkflowsCompleted;
};

export type CompleteRequestWorkflowsResponse =
  | CompleteRequestWorkflowsResponseSuccess
  | CompleteRequestWorkflowsResponseLogisticRequestNotFound
  | CompleteRequestWorkflowsResponseAlreadyCompleted
  | CompleteRequestWorkflowsResponseNotAllRequestWorkflowsCompleted
  | SyncWorkflowSubmitResponse;
